import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=585d4c6b&scoped=true&"
import script from "./AddProject.vue?vue&type=script&lang=js&"
export * from "./AddProject.vue?vue&type=script&lang=js&"
import style0 from "./AddProject.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddProject.vue?vue&type=style&index=1&id=585d4c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d4c6b",
  null
  
)

export default component.exports